import * as React from "react";
import "./style.css";
import { cardData } from "../../Data/cardData";
import TableRestaurantOutlinedIcon from '@mui/icons-material/TableRestaurantOutlined';
import BlenderOutlinedIcon from '@mui/icons-material/BlenderOutlined';
import LightOutlinedIcon from '@mui/icons-material/LightOutlined';
import CottageOutlinedIcon from '@mui/icons-material/CottageOutlined';
import LaptopMacOutlinedIcon from '@mui/icons-material/LaptopMacOutlined';
import WatchOutlinedIcon from '@mui/icons-material/WatchOutlined';
export default function ProductNav() {
  const iconsMap = {
  BlenderOutlinedIcon: BlenderOutlinedIcon,
  TableRestaurantOutlinedIcon: TableRestaurantOutlinedIcon,
  LightOutlinedIcon: LightOutlinedIcon,
  CottageOutlinedIcon: CottageOutlinedIcon,
  LaptopMacOutlinedIcon: LaptopMacOutlinedIcon,
  WatchOutlinedIcon: WatchOutlinedIcon,
};
  const [openCategory, setOpenCategory] = React.useState(null);
  const [openSubFamily, setOpenSubFamily] = React.useState(null);
  const [openThirdLevel, setOpenThirdLevel] = React.useState(null);

  const [path1, setPath1] = React.useState("");
  const [path2, setPath2] = React.useState("");
  const [path3, setPath3] = React.useState("");
  const [path4, setPath4] = React.useState(""); // support niveau 4

  React.useEffect(() => {
    const pathName = decodeURIComponent(window.location.pathname).replace(/%20/g, " ");
    const parts = pathName.split("/");

    setPath1(parts[2] || "");
    setPath2(parts[3] || "");
    setPath3(parts[4] || "");
    setPath4(parts[5] || "");
  }, []);

  const handleCategoryClick = (index, category) => {
    if (!category.sousFamille || category.sousFamille.length === 0) {
      window.location.href = "/collections/tout à -100 dt";
      return;
    }
    setOpenCategory(openCategory === index ? null : index);
    setOpenSubFamily(null);
    setOpenThirdLevel(null);
  };

  const handleSubFamilyClick = (catIndex, subIndex, subItem) => {
    const hasChildren = subItem.sousFamilles && subItem.sousFamilles.length > 0;
    if (!hasChildren) {
      window.location.href = `/collections/${encodeURIComponent(cardData[catIndex].title)}/${encodeURIComponent(subItem.nom)}`;
      return;
    }
    const key = `${catIndex}-${subIndex}`;
    setOpenSubFamily(openSubFamily === key ? null : key);
    setOpenThirdLevel(null);
  };

  const toggleThirdLevel = (key) => {
    setOpenThirdLevel(openThirdLevel === key ? null : key);
  };

  return (
    <div className="productNav">
      <div className="navbarCollection">
        collections
        {path1 && <a href={`/collections/${path1}`}>{` / ${path1}`}</a>}
        {path2 && <a href={`/collections/${path1}/${path2}`}>{` / ${path2}`}</a>}
        {path3 && <a href={`/collections/${path1}/${path2}/${path3}`}>{` / ${path3}`}</a>}
        {path4 && <a href={`/collections/${path1}/${path2}/${path3}/${path4}`}>{` / ${path4}`}</a>}
      </div>

      <ul className="categoryList">
        {cardData.map((category, catIndex) => (
          
          <li key={catIndex}>
            <div
  className={`categoryTitle ${path1 === category.title ? "select" : ""}`}
  onClick={() => handleCategoryClick(catIndex, category)}
>
 

  {category.title}
</div>


            {openCategory === catIndex && category.sousFamille.length > 0 && (
              <ul className="subFamilyList">
                {category.sousFamille.map((subItem, subIndex) => {
                  const subKey = `${catIndex}-${subIndex}`;
                  const hasChildren = subItem.sousFamilles && subItem.sousFamilles.length > 0;

                  return (
                    <li key={subIndex}>
                      <div
                        className={`subfamilyItem1 ${path2 === subItem.nom ? "select" : ""}`}
                        onClick={() => handleSubFamilyClick(catIndex, subIndex, subItem)}
                      >
                         {iconsMap[subItem.iconName] ? (
    React.createElement(iconsMap[subItem.iconName], { fontSize: "small",style: { marginRight: 8 }})
  ) : (
    <span style={{ color: "red" }}>No icon</span>
  )}
                        {subItem.nom} {hasChildren && " ▸"}
                      </div>

                      {hasChildren && openSubFamily === subKey && (
                        <ul className="subSubFamilyList">
                          {subItem.sousFamilles.map((sf, sfIndex) => {
                            const thirdKey = `${subKey}-${sfIndex}`;
                            const hasSubSub = sf.sousSousFamilles && sf.sousSousFamilles.length > 0;

                            return (
                              <li key={sfIndex}>
                                {/* lien de niveau 3 (sf.nom) — si pas d'enfants */}
                                {!hasSubSub && (
                                  <a
                                    href={`/collections/${encodeURIComponent(category.title)}/${encodeURIComponent(subItem.nom)}/${encodeURIComponent(sf.nom)}`}
                                    className={`subfamilyItem2 ${path3 === sf.nom ? "select" : ""}`}
                                  >
                                    {sf.nom}
                                  </a>
                                )}

                                {/* si sf a des sousSousFamilles (niveau 4) */}
                                {hasSubSub && (
                                  <>
                                    {/* affichage du parent du niveau 4 (sf.nom) */}
                                    <div
                                      className={`subfamilyItem2 ${path3 === sf.nom ? "select" : ""}`}
                                      onClick={() => toggleThirdLevel(thirdKey)}
                                    >
                                      {sf.nom} ▸
                                    </div>

                                    {/* niveau 4 : sousSousFamilles (on inclus sf.nom dans le path) */}
                                    {openThirdLevel === thirdKey && (
                                      <ul className="subSubSubList">
                                        {sf.sousSousFamilles.map((subSub, idx) => (
                                          <li key={idx}>
                                            <a
                                              href={`/collections/${encodeURIComponent(category.title)}/${encodeURIComponent(subItem.nom)}/${encodeURIComponent(sf.nom)}/${encodeURIComponent(subSub)}`}
                                              className={`subfamilyItem3 ${path4 === subSub ? "select" : ""}`}
                                            >
                                              {subSub}
                                            </a>
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                  </>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
